import { route, tag, type PageTour } from '../pageTour';

export const userManagementTour: PageTour = {
  id: 'page-user-management',
  version: 2,
  title: 'Users & Roles',
  summary: 'Add users and set what each role is allowed to do.',
  match: route('/user-management'),
  steps: [
    // Only one tab's controls are on screen at a time, so this step is what tells someone on the
    // Users tab that Roles exists (and the other way round).
    {
      target: tag('user-management-tabs'),
      title: 'Users and Roles',
      description:
        'Two tabs: Users for the people who can sign in, Roles for what each kind of user is allowed to do. This tour covers the tab you are on — switch tabs and choose Tour this page again for the other.',
      side: 'bottom',
    },
    {
      target: tag('users-add'),
      title: 'Add a user',
      description: 'Create an account for someone and choose their role — the role decides what they can see and do.',
      side: 'bottom',
      permission: 'users.create',
    },
    {
      target: tag('users-table'),
      title: 'Your users',
      description:
        'Everyone with access, their role and status. Use the actions on a row to edit someone, deactivate them, or choose which sites they can reach.',
      side: 'top',
    },
    {
      target: tag('roles-create'),
      title: 'Create a role',
      description: 'Bundle a set of permissions into a role you can then give to users.',
      side: 'bottom',
      permission: 'roles.create',
    },
    {
      target: tag('roles-list'),
      title: 'Roles',
      description:
        'Each card is a role and the permissions it grants. Open one to see exactly what it allows.',
      side: 'top',
    },
  ],
};
